import axiosInterceptor from '../core/api/interceptors/axiosInterceptor';

export const getCompanyInfo = async () => {
  const res = await axiosInterceptor.get('/company/info');
  return res.data;
};

// ✅ Add update method with combined user and company data
export const updateAccountInfo = async (accountData) => {
  try {
    
    const response = await axiosInterceptor.put('/company/update-account-info', accountData, {
      withCredentials: true
    });
    
    if (response.data.status !== 'Success' || response.data.statusCode !== 200) {
      throw new Error(response.data.message || 'Failed to update account information');
    }
    
    return response.data.payload || response.data;
  } catch (error) {
    console.error('❌ Error updating account info:', error);
    throw error;
  }
};